import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import classnames from "classnames";
import { useApi } from "../../../api";
import config from "../../../config";
import { qs, range, arrayToInt } from "../../../utils"; // Components

import BackButton from "../../../components/BackButton";
import PackageSlider from "../../../components/PackageSlider";
import { RecentSearches } from "../../../components/UserMenu";
import Advertising from "../../../components/Advertising"; //
// Search Components
//

import Results from "./components/Results";
import Filters from "./components/Filters";
import styles from "./search.module.scss";
var isDevelopmentCompany = !config.api.get("project") && !config.api.get("neighbourhood");
export var SearchPage = function SearchPage(a) {
  var b = a.location,
      c = a.showResults,
      d = a.onlyLots,
      e = a.resultsRef,
      f = a.resultsStyle,
      g = useApi(),
      h = "jubilee" === config.api.get("project") || "urban-square" === config.api.get("neighbourhood"),
      i = c ? qs.parse(b.search) : {},
      j = useState(!d && i.similar_properties ? g.packages.retrieve(i.similar_properties) : null),
      k = _slicedToArray(j, 2),
      l = k[0],
      m = k[1];

  i.sort || (i.sort = d || i.sort || !h ? i.sort : "price");
  var n = "object" == typeof i.other_options ? arrayToInt.parse(i.other_options) : i.other_options ? [parseInt(i.other_options)] : void 0,
      o = "object" == typeof i.featured_options ? i.featured_options : i.featured_options ? [i.featured_options] : void 0;
  useEffect(function () {
    var a = !d && i.similar_properties ? g.packages.retrieve(i.similar_properties) : null;
    m(a);
  }, [g.packages, d, i.similar_properties]), l && (i.type = l.propertyType, i.price = l.price, i.bedrooms = l.bedrooms, i.bathrooms = l.bathrooms, i.parking = l.garage); // @TODO find a better way to stringify and parse query values
  // it should be all in one single file.

  var p = d ? {
    estate: "string" == typeof i.estate ? [i.estate] : i.estate,
    neighbourhood: "string" == typeof i.neighbourhood ? [i.neighbourhood] : i.neighbourhood,
    landSize: range.parse(i.land_size),
    frontage: range.parse(i.frontage),
    otherOptions: n,
    statusOptions: o,
    // sort option
    sort: i.sort
  } : {
    estate: "string" == typeof i.estate ? [i.estate] : i.estate,
    neighbourhood: "string" == typeof i.neighbourhood ? [i.neighbourhood] : i.neighbourhood,
    propertyType: "string" == typeof i.type ? [i.type] : i.type,
    price: range.parse(i.price),
    bedrooms: range.parse(i.bedrooms),
    bathrooms: range.parse(i.bathrooms),
    parking: range.parse(i.parking),
    stories: range.parse(i.stories),
    landSize: range.parse(i.land_size),
    frontage: range.parse(i.frontage),
    builder: i.builder,
    otherOptions: n,
    statusOptions: o,
    // sort option
    sort: i.sort
  };
  l && (p.propertyToCompare = l);
  var q = d ? g.lots.list(p) : g.packages.list(p);
  l && l.slug && (q = q.filter(function (a) {
    return l.slug !== a.slug;
  }));
  var r = q.filter(function (a) {
    var b = a.flags;
    return b && b.featured;
  }),
      s = g.current || {},
      t = s.landforsale,
      u = void 0 === t ? [] : t,
      v = classnames({
    "ta-has-results": c
  }),
      w = g.current,
      x = w.townhomes && w.townhomes.length || w.apartments && w.apartments.length || w.packages && w.packages.length,
      y = d && !isDevelopmentCompany ? config.routes.get("landforsale.masterplan") : config.routes.get("property.search"),
      z = d && !isDevelopmentCompany ? "masterplan" : "search";
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "ta-container " + v
  }, x && c ? /*#__PURE__*/React.createElement(BackButton, {
    title: z,
    to: y,
    unless: isDevelopmentCompany ? null : config.routes.get("landforsale.masterplan")
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: "ta-row"
  }, /*#__PURE__*/React.createElement(Filters, {
    filters: g.filters,
    defaultValues: p,
    onlyLotsFilters: d,
    isResultPage: c,
    containsLand: u.length
  }), c ? /*#__PURE__*/React.createElement(Results, {
    ref: e,
    packages: q,
    onlyLotsResults: d,
    style: f
  }) : null), c ? null : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h1", {
    className: styles.title
  }, "Recent Searches"), /*#__PURE__*/React.createElement(RecentSearches, null)), c ? null : /*#__PURE__*/React.createElement(Advertising, {
    className: styles.ad,
    query: [{
      type: "route",
      value: "property.search"
    }],
    height: 180
  })), c ? null : /*#__PURE__*/React.createElement(PackageSlider, {
    title: "Featured properties",
    packages: r
  }));
};
export default SearchPage;